import { withTranslation } from "i18n";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { getResultsStartAsync, resetResultOffset } from "redux/onlineExam/onlineExam.actions";
import { selectErrorFetchingResults, selectIsFetchingResults, selectResultData, selectResultLoadMore } from "redux/onlineExam/onlineExam.selectors";
import { commonStrigns, stringFiles } from "res/strings";
import { createStructuredSelector } from "reselect";
import { Box } from "styled-components/box";
import { SkeletonLine } from "styled-components/skeleton/SkeletonLine";
import { CookieUtils } from "utils";
import ResultCard from "../../components/assessment/ResultCard";



const Result = ({ t }) => {
  const [show, setShow] = useState(true);

  const dispatch = useDispatch();
  const router = useRouter();


  const cookieInstance = new CookieUtils();

  const studentID = cookieInstance.getCookie("studentID");
  const semesterID = cookieInstance.getCookie("semesterID");


  const {
    resultData,
    isFetchingResults,
    errorFetchingResults,
    resultLoadMore,
  } = useSelector(
    createStructuredSelector({
      resultData: selectResultData,
      isFetchingResults: selectIsFetchingResults,
      errorFetchingResults: selectErrorFetchingResults,
      resultLoadMore: selectResultLoadMore,
    })
  );

  useEffect(() => {
    dispatch(resetResultOffset());
    getResultList()
  }, []);


  const getResultList = () => {
    dispatch(getResultsStartAsync({ studentID: studentID, semesterID: semesterID, isShowArchived: false }))
  }



  return (
    <Box className="w-100 d-flex flex-column p-2">
      {isFetchingResults && !resultLoadMore ? (
        //Loading
        <>
          {[1, 2, 3, 4, 5, 6].map((item, idx) => (
            <Box key={idx} width="100%" height="50px" className="my-1">
              <SkeletonLine />
            </Box>
          ))}
        </>
      ) : resultData && !errorFetchingResults ? (
        //Show Data

        <>
          <InfiniteScroll
            dataLength={resultData.length} //This is important field to render the next data
            next={() => getResultList()}
            hasMore={resultLoadMore}
            loader={<Spinner className='d-flex mx-auto align-self-center' animation="border" />}
            // endMessage={
            //   <p className="text-success" style={{ textAlign: 'center' }}>
            //     {t(onlineExamString.listFinish)}
            //   </p>
            // }
            // below props only if you need pull down functionality
            refreshFunction={() => {
              dispatch(resetResultOffset())
              getResultList();
            }}
            pullDownToRefresh
            pullDownToRefreshThreshold={100}
            pullDownToRefreshContent={
              <p style={{ textAlign: 'center' }}>دریافت مجدد لیست</p>
            }
            releaseToRefreshContent={
              <p style={{ textAlign: 'center' }}>دریافت مجدد لیست</p>
            }
          >
            {resultData.map((exam, id) => (
              <ResultCard {...exam} statusAssignmentName={false} key={id} />
            ))}

          </InfiniteScroll>
          {resultData.length === 0 &&
            <h3 className="text-center mt-5 app-text-gray">نتیجه ای برای شما ثبت نشده است</h3>
          }
          {!resultLoadMore && <Button className="w-50 mx-auto my-1" onClick={() => {
            router.push(`/onlineExam/archive`)
          }}>
            آرشیو نتایج
          </Button>}
        </>
      ) : (
        //Error
        <Alert show={show} variant="danger">
          <Alert.Heading>{t(commonStrigns.error)}</Alert.Heading>
          <p>
            {errorFetchingResults}
          </p>
          <hr />
          <div >
            <Button onClick={() => getResultList()} variant="outline-danger">
              {t(commonStrigns.retry)}
            </Button>
          </div>
        </Alert>
      )}
    </Box>
  );
};

export default withTranslation(stringFiles.common)(Result);
